module.exports = __webpack_public_path__ + "img/00021.a6f55445.webp";